import { apiClient } from "./client";

export type PractitionerLink = {
  id: string;
  last_name: string;
  first_name: string | null;
  first_initial: string | null;
  rpps: string | null;
  email: string | null;
  phone: string | null;
  display_name: string;
  bio: string | null;
  languages: string[];
  has_photo: boolean;
};

export type Profile = {
  id: string;
  email: string;
  full_name: string | null;
  tenant_id: string | null;
  is_god: boolean;
  mfa_enabled: boolean;
  locale: string;
  theme_pref: string;
  practitioner: PractitionerLink | null;
};

export async function getProfile(): Promise<Profile> {
  const { data } = await apiClient.get<Profile>("/api/v1/me/profile");
  return data;
}

export type ProfileUpdate = {
  full_name?: string | null;
  locale?: string;
  theme_pref?: string;
  practitioner_phone?: string | null;
  practitioner_bio?: string | null;
  practitioner_languages?: string[];
};

export async function updateProfile(p: ProfileUpdate): Promise<Profile> {
  const { data } = await apiClient.patch<Profile>("/api/v1/me/profile", p);
  return data;
}

export async function changePassword(
  current_password: string,
  new_password: string,
): Promise<void> {
  await apiClient.post("/api/v1/me/password", { current_password, new_password });
}

export async function uploadMyPhoto(file: File): Promise<PractitionerLink> {
  const form = new FormData();
  form.append("file", file);
  const { data } = await apiClient.put<PractitionerLink>(
    "/api/v1/me/practitioner/photo",
    form,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  return data;
}

export async function deleteMyPhoto(): Promise<void> {
  await apiClient.delete("/api/v1/me/practitioner/photo");
}

export async function fetchPractitionerPhoto(practitionerId: string): Promise<Blob | null> {
  try {
    const { data } = await apiClient.get<Blob>(
      `/api/v1/practitioners/${practitionerId}/photo`,
      { responseType: "blob" },
    );
    return data;
  } catch {
    return null;
  }
}


export async function downloadMyCv(): Promise<Blob> {
  const { data } = await apiClient.get<Blob>("/api/v1/me/practitioner/cv.pdf", {
    responseType: "blob",
  });
  return data;
}
